import miteeRoleMenuManage from './form-maintenance-roleMenuManage';



// 为组件添加 install 方法，用于按需引入
miteeRoleMenuManage.install = function (Vue) {
    Vue.component(miteeRoleMenuManage.name, miteeRoleMenuManage)
}




export default miteeRoleMenuManage